import { render, staticRenderFns } from "./AvgMonthlySalesByIntroducerReport.vue?vue&type=template&id=12f3bf9a&"
import script from "./AvgMonthlySalesByIntroducerReport.vue?vue&type=script&lang=js&"
export * from "./AvgMonthlySalesByIntroducerReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports